import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import { FaPersonWalkingLuggage } from "react-icons/fa6";
import ViewLeave from "./view";
import EditLeave from "./edit";
import { MODULE_LEAVE_REQUESTS } from "variables/modules";
import LeaveRequests from "./index";

const leavesRequestRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Leave Requests",
		basePath: "leave-requests",
		mainComponent: <LeaveRequests />,
	    layout: "/console",	   
	    icon: <FaPersonWalkingLuggage className="icon-item" />,
	    subTitle:"Leave Request",
	    viewComponent: <ViewLeave />,
	    createComponent: <EditLeave />,
	    editComponent: <EditLeave />,
		level:4,
		moduleId: MODULE_LEAVE_REQUESTS,
	})
]

export default leavesRequestRoutes;